export const FETCH_PETTY_CASH_TRANSACTIONS = "FETCH_PETTY_CASH_TRANSACTIONS";
export const FETCH_UNALLOCATED_TRANSACTIONS = "FETCH_UNALLOCATED_TRANSACTIONS";
